// router.js
import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/Home.vue';
import Products from '@/pages/Products.vue';
import Product from '@/pages/Product.vue';
import Collection from '@/pages/Collection.vue';
import History from '@/pages/History.vue';

const mdpConfig = require('../mdp.config');

function getComponent(is) {
  switch (is) {
    case 'Home':
      return Home;
    case 'Products':
      return Products;
    case 'Product':
      return Product;
    case 'Collection':
      return Collection;
    case 'History':
      return History;
    default:
      return null;
  }
}


function addRoutes(routes, parentPath, parentId, sections) {
  sections.forEach((section, index) => {
    const id = section.id ? section.id : `${index + 1}`;
    const localPath = section.path ? section.path : `/${index + 1}`;
    const name = parentId !== '' ? `${parentId}|${id}` : id;
    const path = parentPath !== '/' ? parentPath + localPath : localPath;
    const sectionPath = parentPath !== '/' ? parentPath + section.path : section.path;
    routes.push({
      path, name, component: getComponent(section.is),
    });
    if (section.routes) {
      addRoutes(routes, sectionPath, name, section.routes);
    }
    if (section.products) {
      addRoutes(routes, sectionPath, name, section.products);
    }
  });
}


// function addCollection(routes, collection) {
//   routes.push({ path: collection.path, name: collection.id, collection });
//   addRoutes(routes, collection.path, collection.id, collection.sections);
// }


function getRoutes(data) {
  const routes = [];
  addRoutes(routes, '', '', data.routes);
  // console.info('add routes', routes);
  return routes;
}


Vue.use(Router);

export function createRouter(version) {// eslint-disable-line

  const config = mdpConfig[version];
  // console.info('ADD ROUTES', config);
  const routes = getRoutes(config);
  // console.info('routes', routes);

  /* home default redirection */
  const homeRouteIndex = routes.findIndex(r => r.name === 'home');
  const defaultRouteName = window.___home;
  if (homeRouteIndex > -1 && defaultRouteName) {
    routes[homeRouteIndex].redirect = () => ({ name: defaultRouteName });
  }

  return new Router({
    routes,
    scrollBehavior() {
      return {
        x: 0,
        y: 0,
      };
    },
  });
}

